import { Link } from 'react-router-dom';
import { AiFillInstagram } from 'react-icons/ai';
import { IoLogoWhatsapp } from 'react-icons/io';
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import logo from '../assets/Logo.png';

function Footer() {
    return (
        <footer className="border-t border-slate-200/80 bg-slate-950 text-white">
            <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-[1.2fr_0.8fr_0.8fr] lg:px-8">
                <div>
                    <div className="flex items-center gap-3">
                        <img src={logo} alt="CET & RC" className="h-14 w-14 object-contain" />
                        <div>
                            <p className="font-brand text-2xl font-black uppercase tracking-[0.08em] text-white sm:text-3xl">CET & RC</p>
                            <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.24em] text-primary-200/90">Engineering confidence, built right.</p>
                        </div>
                    </div>
                    <p className="mt-4 max-w-xl text-xs leading-7 text-slate-300 md:text-sm">
                        Consultancy, testing, surveying, and construction care for dependable project outcomes.
                    </p>
                    <div className="mt-5">
                        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/50">Businesses</p>
                        <div className="mt-3 flex flex-col gap-2 text-sm text-slate-300">
                            <Link to="/about" className="transition hover:text-white">Shri Shiyamala Consultancy</Link>
                            <Link to="/about" className="transition hover:text-white">Kodai Constructions</Link>
                        </div>
                    </div>
                </div>

                <div>
                    <h3 className="text-sm font-semibold uppercase tracking-[0.3em] text-white/60">Quick links</h3>
                    <div className="mt-5 flex flex-col gap-3 text-sm text-slate-300">
                        <Link to="/" className="transition hover:text-white">Home</Link>
                        <Link to="/services" className="transition hover:text-white">Services</Link>
                        <Link to="/about" className="transition hover:text-white">About</Link>
                        <Link to="/contact" className="transition hover:text-white">Contact</Link>
                        <Link to="/terms-and-conditions" className="transition hover:text-white">Terms &amp; Conditions</Link>
                        <Link to="/privacy-policy" className="transition hover:text-white">Privacy Policy</Link>
                    </div>
                </div>

                <div>
                    <h3 className="text-sm font-semibold uppercase tracking-[0.3em] text-white/60">Contact</h3>
                    <div className="mt-5 space-y-4 text-sm text-slate-300">
                        <p className="flex items-center gap-3"><FaPhoneAlt className="text-primary-300" /> +91 97884 63091</p>
                        <a
                            href="https://wa.me/919788463091"
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-3 transition hover:text-white"
                        >
                            <IoLogoWhatsapp className="text-primary-300" /> +91 97884 63091
                        </a>
                        <a
                            href="https://www.instagram.com/cet_rc"
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-3 transition hover:text-white"
                        >
                            <AiFillInstagram className="text-primary-300" /> cet_rc
                        </a>
                        <p className="flex items-center gap-3"><FaEnvelope className="text-primary-300" /> cetrc1970@gmail.com</p>
                        <p className="flex items-center gap-3"><FaMapMarkerAlt className="text-primary-300" /> Anaiyur, Madurai</p>
                    </div>
                </div>
            </div>

            <div className="border-t border-white/10 px-4 py-5 text-center text-xs text-white/45 sm:px-6 lg:px-8">
                © {new Date().getFullYear()} CET & RC. All rights reserved. Built by{' '}
                <a href="https://www.creaviq.com" target="_blank" rel="noreferrer" className="text-white/70 underline transition hover:text-white">
                    Creaviq
                </a>
                .
            </div>
        </footer>
    );
}

export default Footer;
